<template>
    <div class="ask">
        <div class="pc">
            <a href="http://chat.talk99.cn/chat/chat/p.do?c=10039109&f=10058528&g=10060916" target="_blank">售前<br/>咨询</a>
            <a href="http://chat.talk99.cn/chat/chat/p.do?c=10039109&f=10058528&g=10060912" target="_blank">加盟<br/>咨询</a>
            <a href="https://chat7731.talk99.cn/chat/chat/p.do?g=10070844&md=2&c=10039109&v=360ee8d0ee31c8992fc4210a798f2874&u=1f9bdf1d4b994876a3e60d096233782b&f=10058528&site=0&p0=https%3A%2F%2Fwww.fb1952.com%2Fmain.php&ct=42&lang=sc&refer=&loc=https%3A%2F%2Fwww.fb1952.com%2Fmain.php&_d=1607071443831" target="_blank">免费<br/>电话</a>
        </div>
        <a class="phone" href="http://chat.talk99.cn/chat/chat/p.do?c=10039109&f=10058528&g=10060915"  target="_blank">
            <div class="pImg">
                <img src="../assets/phone_zxzx.png" alt="">
            </div>
            <p>在线咨询</p>
        </a>

    </div>
</template>

<script>
    export default {
        name: "ask"
    }
</script>

<style lang="scss" scoped>
.ask{
    position: fixed;
    right:0;
    top:50%;
    z-index: 1000;
   .pc{
       display: flex;
       flex-direction: column;
       a{
           height: 56px;
           text-align: center;
           border-left: 1px solid #c7c7c7;
           border-right: 1px solid #c7c7c7;
           border-top: 1px solid #c7c7c7;
           width:56px;
           font-size: 13px;
           color: #999;
           display: flex;
           flex-direction: column;
           align-items: center;
           justify-content: center;
       }
       a:last-child{
           border-bottom: 1px solid #c7c7c7;
       }
   }
    .phone{
        display: none;
    }
    @media screen and (max-width: 1000px){
        .pc{
            display: none;
        }
        .phone{
            display: inline-block;
            width: 60px;
            height: auto;
            position: fixed;
            top: 50%;
            right: 5px;
            z-index: 1;
            padding: 10px 5px;
            background: #4a332a;
            border-radius: 10px;
            text-align: center;
            .pImg{
                width:50%;
                margin: 0 auto;
                img{
                    width:100%;
                }
            }
            p{
                font-size: 12px;
                text-align: center;
                color: #fff;
                margin: 0 auto;
                margin-top: 5px;
            }
        }
    }
}
</style>
